/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSupportBulkUploadLtxFilesMutationRequest, AuditSupportBulkUploadLtxFilesMutationResponse, AuditSupportBulkUploadLtxFiles401, AuditSupportBulkUploadLtxFiles403 } from "../models/AuditSupportBulkUploadLtxFiles";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditSupportBulkUploadLtxFiles } from "../axios/auditSupportBulkUploadLtxFiles";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditSupportBulkUploadLtxFilesMutationKey = () => [{ url: '/audit-support/v1/ltx-files/bulk-upload' }] as const

export type AuditSupportBulkUploadLtxFilesMutationKey = ReturnType<typeof auditSupportBulkUploadLtxFilesMutationKey>

export function auditSupportBulkUploadLtxFilesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AuditSupportBulkUploadLtxFilesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = auditSupportBulkUploadLtxFilesMutationKey()
        return mutationOptions<AuditSupportBulkUploadLtxFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadLtxFiles401 | AuditSupportBulkUploadLtxFiles403>, {data: AuditSupportBulkUploadLtxFilesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return auditSupportBulkUploadLtxFiles(data, config)
          },
        })

}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload LTX files
 * {@link /audit-support/v1/ltx-files/bulk-upload}
 */
export function useAuditSupportBulkUploadLtxFiles<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditSupportBulkUploadLtxFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadLtxFiles401 | AuditSupportBulkUploadLtxFiles403>, {data: AuditSupportBulkUploadLtxFilesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AuditSupportBulkUploadLtxFilesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditSupportBulkUploadLtxFilesMutationKey()

          const baseOptions = auditSupportBulkUploadLtxFilesMutationOptions(config) as UseMutationOptions<AuditSupportBulkUploadLtxFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadLtxFiles401 | AuditSupportBulkUploadLtxFiles403>, {data: AuditSupportBulkUploadLtxFilesMutationRequest}, TContext>
          

          return useMutation<AuditSupportBulkUploadLtxFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadLtxFiles401 | AuditSupportBulkUploadLtxFiles403>, {data: AuditSupportBulkUploadLtxFilesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditSupportBulkUploadLtxFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadLtxFiles401 | AuditSupportBulkUploadLtxFiles403>, {data: AuditSupportBulkUploadLtxFilesMutationRequest}, TContext>
      
}